import { render } from "./IconVerticalThreeDots.vue?vue&type=template&id=cb976b80"
import script from "./IconVerticalThreeDots.vue?vue&type=script&lang=ts"
export * from "./IconVerticalThreeDots.vue?vue&type=script&lang=ts"
script.render = render

export default script